import { RealTimeDataStore } from "@app/services/store/real-time-data-store";
import { WebStompEntitySubscriber } from "@app/services/webstomp/web-stomp-entity-subscriber.service";
import { Injectable, inject } from "@angular/core";
import {
  ResourceAvailability,
  ResourceAvailability_DetailProjection
} from "@app/models/rest/resource-availability";
import { ResourceAvailabilityRestService } from "@app/services/hal/resource-availability-rest.service";
import moment from "moment";
import { Team } from "@app/models/rest/team";
import {
  HateoasResourceService,
  PagedResourceCollection
} from "@lagoshny/ngx-hateoas-client";

@Injectable({ providedIn: "root" })
export class ResourceAvailabilityStore extends RealTimeDataStore<ResourceAvailability> {
  constructor() {
    const resourceAvailabilityRestService = inject(
      ResourceAvailabilityRestService
    );
    const webStompSubscriber = inject(WebStompEntitySubscriber);
    const hateoasResourceService = inject(HateoasResourceService);

    super(
      resourceAvailabilityRestService,
      webStompSubscriber,
      hateoasResourceService
    );
    super.subscribeToMessaging("ResourceAvailability");
  }

  public findByTimeRange(from: Date, to: Date): Promise<any> {
    return this.loadWithSearch(
      "findByTimeRange",
      {
        params: {
          fromDate: moment(from).toISOString(),
          toDate: moment(to).toISOString(),
          projection: "detail"
        }
      },
      false
    );
  }

  public findByResourceAndTimeRange(
    resourceId: number,
    from: Date,
    to: Date,
    detached = false
  ): Promise<PagedResourceCollection<ResourceAvailability_DetailProjection>> {
    return this.loadProjectionWithSearch(
      ResourceAvailability_DetailProjection,
      "findByResourceAndTimeRange",
      {
        params: {
          resourceId: resourceId,
          fromDate: moment(from).toISOString(),
          toDate: moment(to).toISOString(),
          projection: "detail"
        }
      }
    );
  }

  public updateResourceAvailabilityRange(
    resourceAvailability: ResourceAvailability,
    from: Date,
    to: Date
  ): Promise<any> {
    return new Promise<any>((resolve, reject) => {});
  }

  findByTimeRangeAndTeams(
    from: Date,
    to: Date,
    teamList: Team[]
  ): Promise<any> {
    console.log(teamList);

    let teamListString = teamList.map((value) => value.id).join(",");
    return this.loadWithSearch(
      "findByTimeRangeAndTeams",
      {
        params: {
          fromDate: moment(from).toISOString(),
          toDate: moment(to).toISOString(),
          teamsList: teamListString,
          projection: "detail"
        }
      },
      false
    );
  }
}
